import { AdminNavRouteStaticDataType, NAV_ROUTE_KEY_TYPE } from './types';
import { NAVIGATION_ADMIN_ICON_LIST } from './constants';
import { NAVIGATION_ADMIN_MENU_LIST } from './enums';
import { SUB_ADMIN_MENU_REGEX_MAP } from './regex';
import { BE_NAVIGATION_DATA_TYPE } from '../../types';

const transformNavigationData = (
  navData: BE_NAVIGATION_DATA_TYPE[]
): AdminNavRouteStaticDataType[] =>
  navData
    .filter(item => item.name)
    .map(item => ({
      id: item.id as NAVIGATION_ADMIN_MENU_LIST,
      name: item.name,
      linkPattern: item.linkPattern,
      icon: NAVIGATION_ADMIN_ICON_LIST[item.id],
      permissionsMap: item?.permissionsMap ?? [],
      subMenu: Array.isArray(item.subMenu)
        ? item.subMenu.map(({ id, name, link, showAfterPermissionsCheck = false }) => ({
            id: id as NAV_ROUTE_KEY_TYPE,
            name,
            link,
            showAfterPermissionsCheck,
            subLinkPattern: SUB_ADMIN_MENU_REGEX_MAP[id as keyof typeof SUB_ADMIN_MENU_REGEX_MAP],
          }))
        : [],
    }));

export default transformNavigationData;
